import type { Company } from '../../../domain/company';
import { useDispatchTrackEventWithLocation } from '../../../services/tracking/hooks/useDispatchTrackEventWithLocation';

import type { TrafficVisitsTab } from './TrafficVisits';

const TRAFFIC_VISITS_TRACKING: Record<TrafficVisitsTab, string> = {
  monthly: 'monthly visits',
  unique: 'unique visitors',
};

export const useTrafficVisitsTracking = (company: Company) => {
  const dispatchTrackEventWithLocation = useDispatchTrackEventWithLocation();

  const trackSelectTab = (tabName: TrafficVisitsTab) => {
    dispatchTrackEventWithLocation(
      'company data',
      'select visits over time by',
      `visits over time/${TRAFFIC_VISITS_TRACKING[tabName]}/${company.domain}`
    );
  };

  return {
    trackSelectTab,
  };
};
